export enum ScreenSize {
    Large = 1,
    Medium,
    Small,
}
